import React from "react";
import "../css/SaveBar.scss";  // asigură-te că acest fișier conține clasa `training-save-bar`

export default function SaveBar({ visible, onSave, onCancel }) {
  return (
    <div className={`save-bar ${visible ? "visible" : ""}`}>
      <button className="save-button" onClick={onSave}>Save</button>
      <button className="cancel-button" onClick={onCancel}>Cancel</button>
    </div>
  );
}
